import { render, staticRenderFns } from "./EventLevel.vue?vue&type=template&id=0534d415&scoped=true&"
import script from "./EventLevel.vue?vue&type=script&lang=js&"
export * from "./EventLevel.vue?vue&type=script&lang=js&"
import style0 from "./EventLevel.vue?vue&type=style&index=0&id=0534d415&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0534d415",
  null
  
)

export default component.exports